import { sendSpeedCurveLuxEvent } from '@/utils/performance-monitoring/speedcurve.js'

/**
 * @param {boolean} shouldSendEventsPreviousPage
 * @param {boolean} shouldInitEventsNextPage
 */
export function sendSpeedCurveLuxEventGuard(shouldSendEventsPreviousPage, shouldInitEventsNextPage) {
  sendSpeedCurveLuxEvent(shouldSendEventsPreviousPage, shouldInitEventsNextPage)
}
